export interface IdentifyTraits {
    email: string;
    name: string;
    accountId: string;
}

export interface WeavixTelemetryEvent {
    id: string;
    originalTimestamp: Date;
    source: string;
    event: string;
    environment: string;
    context: any;
    properties: any;
    userId?: string;
    errorCount?: number;

    // Populated by Segment
    anonymousId?: string;
    receivedAt?: Date;
    sentAt?: Date;
}

export enum StProperty {
    accountId = 'accountId',
    action = 'action',
    component = 'component',
    count = 'count',
    dimensions = 'dimensions',
    endpoint = 'endpoint',
    errorData = 'errorData',
    id = 'id',
    method = 'method',
    object = 'object',
    page = 'page',
    query = 'query',
    source = 'source',
    type = 'type',
    unit = 'unit',
    version = 'version',
    visible = 'visible',
}

export type StProperties = { [key in StProperty]?: any };
export const allowedKeys = new RegExp((Object.keys(StProperty).join('|')), 'i');

// Any updates to events needs to be documented in our Metric Dictionary Wiki
// https://weavix.atlassian.net/wiki/spaces/EN/pages/487063577/Metric+Dictionary

export enum StObject {
    AccountSwitcher = 'AccountSwitcher',
    AnonymousUser = 'AnonymousUser',
    CallCamera = 'CallCamera',
    CallAudio = 'CallAudio',
    Channel = 'Channel',
    ChannelMessage = 'ChannelMessage',
    ChannelNotificationSettings = 'ChannelNotificationSettings',
    ChannelTagFilter = 'ChannelTagFilter',
    MapPlaybackTimeSelection = 'MapPlaybackTimeSelection',
    MessageAttachment = 'MessageAttachment',
    Tag = 'Tag',
    UserProfile = 'UserProfile',
    VoiceCall = 'VoiceCall',
    VideoCall = 'VideoCall',
    UserAvatar = 'UserAvatar',
    ApiKey = 'ApiKey',
    Beacon = 'Beacon',
    Bulk = 'Bulk',
    Company = 'Company',
    Dashboard = 'Dashboard',
    DashboardWidget = 'DashboardWidget',
    Facility = 'Facility',
    Folder = 'Folder',
    Geofence = 'Geofence',
    GeofenceType = 'GeofenceType',
    FloorPlan = 'FloorPlan',
    Meeting = 'Meeting',
    PermissionGroup = 'PermissionGroup',
    Person = 'Person',
    Ptt = 'Ptt',
    Structure = 'Structure',
    TableBulkAction = 'TableBulkAction',
    TableRowAction = 'TableRowAction',
    Tts = 'Tts',
    WifiRouter = 'WifiRouter',
    Workflow = 'Workflow',
    WorkForm = 'WorkForm',
    Wrangler = 'Wrangler',
    Item = 'Item',
    OfflineMode = 'OfflineMode',
    FacilityShare = 'FacilityShare',
}

export enum StAction {
    Admitted = 'Admitted',
    Canceled = 'Canceled',
    Cleared = 'Cleared',
    Clicked = 'Clicked',
    Copied = 'Copied',
    Created = 'Created',
    Deleted = 'Deleted',
    Disabled = 'Disabled',
    Duplicate = 'Duplicate',
    Edited = 'Edited',
    Enabled = 'Enabled',
    Ended = 'End',
    Joined = 'Joined',
    Left = 'Left',
    Messaged = 'Messaged',
    Moved = 'Moved',
    Pressed = 'Pressed',
    Rejected = 'Rejected',
    Requested = 'Requested',
    Removed = 'Removed',
    Resized = 'Resized',
    Sent = 'Sent',
    Set = 'Set',
    Started = 'Start',
    Subscribed = 'Subscribed',
    Toggled = 'Toggled',
    Unsubscribed = 'Unsubscribed',
    Updated = 'Updated',
    Uploaded = 'Uploaded',
    Exported = 'Exported',
    Imported = 'Imported',
}
